import React from "react";

import { Navigate } from "react-router-dom";

import { useIsWorkspaceInsightsEnabled } from "src/analytics/workspace/useIsWorkspaceInsightsEnabled";
import { DashboardPageParams, getUrlToWsDashboard } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type Props = {
  children: React.ReactNode;
};

// A direct URL to workspace insights bypasses the (hidden) nav item, so send
// visitors without access back to the workspace dashboard.
export const WorkspaceInsightsRouteGuard: React.FC<Props> = ({ children }) => {
  const { isEnabled } = useIsWorkspaceInsightsEnabled();
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  if (isEnabled) {
    return <>{children}</>;
  }

  return <Navigate replace to={getUrlToWsDashboard({ orgId, wsId })} />;
};
